import DOMPurify from 'isomorphic-dompurify';

export default (context, inject) => {
  inject('sanitize', (dirtyHtml) => {
    return DOMPurify.sanitize(dirtyHtml);
  });
};